/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArticleDto } from '../models/ArticleDto';
import type { ManageArticleDto } from '../models/ManageArticleDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ArticleService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public markAsViewed(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/article/{id}/view',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ArticleDto
     * @throws ApiError
     */
    public create(
        requestBody: ManageArticleDto,
    ): CancelablePromise<ArticleDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/article',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ArticleDto
     * @throws ApiError
     */
    public findAll(): CancelablePromise<Array<ArticleDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/article',
        });
    }

    /**
     * @returns ArticleDto
     * @throws ApiError
     */
    public findAllAdmin(): CancelablePromise<Array<ArticleDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/article/all',
        });
    }

    /**
     * @param id
     * @returns ArticleDto
     * @throws ApiError
     */
    public release(
        id: string,
    ): CancelablePromise<ArticleDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/article/{id}/release',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns ArticleDto
     * @throws ApiError
     */
    public update(
        id: string,
        requestBody: ManageArticleDto,
    ): CancelablePromise<ArticleDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/article/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public remove(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/article/{id}',
            path: {
                'id': id,
            },
        });
    }

}
